import { IOrderCardProps } from '@model/OrdersHistory.model';
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './MyOrdersPage.module.css';
import { formatDateTime, formatMoney } from '../../../Logic/Functions/UtilsFunctions';

const OrderCard: React.FC<IOrderCardProps> = ({
  id,
  orderNumber,
  itemsCount,
  totalToBePaid,
  createdAt,
  status,
}) => {
  const navigate = useNavigate();
  const openOrder = useCallback(() => {
    navigate(`/orders/${id}`);
  }, [navigate, id]);

  return (
    <div
      className={styles.orderCard}
      role="button"
      tabIndex={0}
      onClick={openOrder}
      data-testid={`order-card-${id}`}
    >
      <div className={styles.orderCardLeft}>
        <div className={styles.orderCardId} data-testid="order-card-number">
          {orderNumber}
        </div>

        <div className={styles.orderCardMetaRow}>
          <span className={styles.orderCardMeta} data-testid="order-card-date">
            {formatDateTime(createdAt)}
          </span>
        </div>
      </div>

      <div className={styles.orderCardRight}>
        <span
          className={`${styles.orderCardStatus} ${styles[`orderCardStatus${status}`]}`}
          data-testid="order-card-status"
        >
          {status}
        </span>
        <div className={styles.orderCardTotal} data-testid="order-card-total">
          {formatMoney(Number(totalToBePaid || 0))}
        </div>
      </div>
    </div>
  );
};

export default OrderCard;
